import type { ExtractPropTypes, PropType, StyleValue, Component } from 'vue'
import type _TitleBar from './title-bar.vue'
import type { ComponentType } from '../../../constants'

export const sdTitleBarProps = {
    type      : { type: String as PropType<ComponentType>, default: 'primary' },
    icon      : { type: Object as PropType<Component> },
    iconColor : { type: String                        },
    iconSize  : { type: Number                        },
    title     : { type: String, default: ''           },
    subTitle  : { type: String, default: ''           },
    desc      : { type: String, default: ''           },
    arrow     : { type: Boolean, default: false       },

    headClass : { type: String },
    headStyle : { type: [String, Object] as PropType<StyleValue> },
    bodyClass : { type: String },
    bodyStyle : { type: [String, Object] as PropType<StyleValue> },
}

export type SdTitleBarProps    = ExtractPropTypes<typeof sdTitleBarProps>
export type SdTitleBarInstance = InstanceType<typeof _TitleBar>
